<template>
        <div id="vuecropperbox">
             <div class="btnbox">
                <div class="imgbox">
                    <img :src="defaultimg" >
                    <div class="uplaodpross" v-if="is_procc_show">
                        <span class="jindu">
                            <i class="jindu_tiao" :class="{'jindu_red':is_upload_error}" :style="{width:pross_num}"></i>
                            <i class="jindu_num">{{ pross_num }}</i>
                        </span>
                        
                    </div>
                    <label :for="inputid"></label>
                    <input :id="inputid" type="file" accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
                </div>
             </div>
        </div>

</template>

<script>
    import 'vue-cropper/next/dist/index.css'
    import {VueCropper} from 'vue-cropper/next'
    import http from '@/tools/Http';

    export default {
        name:"input",
        components:{
            VueCropper
        },
        data(){
            return{
                defaultimg:require("@/assets/tianjia.png"),
                pross_num:"0%",
                is_procc_show:false,
                is_upload_error:false,
                fileName:"",
                filePath:"",
                filebox:""

            }
        },
        props:{
            modelValue:{
                // type: Array,
                default:""
            },
            inputid:{
                type:String,
                required:true
            }
        },
        async mounted(){
            if(this.modelValue.length>0){
                this.filePath=this.modelValue
            }
        },
        methods:{
                //选择图片
                selectImg (e) {
                        if(e.target.files.length==0){
                            return
                        }
                        this.is_procc_show=true
                        this.is_upload_error=false
                        this.pross_num="0%"
                        this.file = e.target.files[0]
                        this.fileName=this.file.name
                        if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(e.target.value)) {
                            this.$message({
                            message: '图片类型要求：jpeg、jpg、png',
                            type: "error"
                            });
                            return false
                        }
                        if(window.FileReader){
                             let reader = new FileReader();
                             let base64String=""
                            reader.readAsDataURL(this.file);
                            reader.onload = e=> {
                                this.defaultimg=e.target.result
                                
                                console.log(this.defaultimg)
                                
                            };
                            
                            this.uploadfile(this.file)
                        }
                },
               
                uploadfile(file){
                        let formData=new FormData();
                        formData.append('file',file)

                        http.post('/file/uplaods',formData,{
                                headers:{
                                    'Content-Type':'multipart/form-data'
                                },
                                onUploadProgress:progressEvent=>{
                                   
                                    this.pross_num= Math.floor( (progressEvent.loaded/progressEvent.total)*100 )+"%"
                                }
                        }).then(res=>{
                            console.log(res)
                            if(res.status==0){
                                this.filePath=res.data
                                this.$emit('update:modelValue', this.filePath)

                            }else{
                                this.is_upload_error=true
                            }
                        }).catch(error=>{
                            console.log(error)
                            this.is_upload_error=true
                        })

                }

            }
    }
</script>
<style scoped>
    #vuecropperbox{
        width: 100%;
        height: 100%;
        float: left;
        border:1px solid #ccc;
        overflow: hidden;
    }
    #vuecropperbox .btnbox{
        width: 100%;
        height: 100%;
        float: left;
       
    }
    #vuecropperbox .btnbox .imgbox{
         position: relative;
         width: 100%;
         height: 100%;
         float: left;
    }
    #vuecropperbox .btnbox .imgbox img{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }
    #vuecropperbox .btnbox .imgbox .uplaodpross{
        width: 100%;
        height: 100%;
        position: absolute;
        background-color: rgba(0,0,0,.5);
    }
    #vuecropperbox .btnbox .imgbox .uplaodpross .jindu{
        width: 100%;
        height: 30px;
        display: block;
        position: absolute;
        top: calc( 50% - 15px );
        background-color: rgba(0,0,0,.5);
        left: 0;
    }
    #vuecropperbox .btnbox .imgbox .uplaodpross .jindu .jindu_tiao{
        height: 30px;
        display: block;
        position: absolute;
        top: 0;
        background-color: rgba(11, 157, 8, 0.5);
        left: 0;
    }
    #vuecropperbox .btnbox .imgbox .uplaodpross .jindu .jindu_tiao.jindu_red{
        background-color: rgba(189, 21, 26, 0.5);
    }
    #vuecropperbox .btnbox .imgbox .uplaodpross .jindu .jindu_num{
        width: 100%;
        height: 30px;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        color: #fff;
        text-align: center;
        line-height: 30px;
        font-size: 12px;
        font-style: normal;
    }
    #vuecropperbox .btnbox .imgbox label{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        display: block;
    }
    #vuecropperbox .btnbox .imgbox input{
        display: none;
    }

</style>
